import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4173c57a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-background"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-row" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "pricing" }, "PRICING")
], -1))
const _hoisted_3 = { class: "plan-section" }
const _hoisted_4 = { class: "plan" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "plan-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "version" }, "Free"),
  /*#__PURE__*/_createElementVNode("h3", { class: "price-dollars" }, "$0.00/mo"),
  /*#__PURE__*/_createElementVNode("p", null, "+ usage")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "INCLUDES", -1))
const _hoisted_7 = { class: "list" }
const _hoisted_8 = { class: "list-item" }
const _hoisted_9 = { class: "list-item" }
const _hoisted_10 = { class: "list-item" }
const _hoisted_11 = { class: "list-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "purchase-selected",
  disabled: ""
}, "Created", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, "NO CC REQUIRED", -1))
const _hoisted_14 = { class: "plan-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "plan-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "version-center" }, "Pro"),
  /*#__PURE__*/_createElementVNode("h3", { class: "price-dollars" }, "$5.00/mo"),
  /*#__PURE__*/_createElementVNode("p", null, "+ usage")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "INCLUDES", -1))
const _hoisted_17 = { class: "list" }
const _hoisted_18 = { class: "list-item" }
const _hoisted_19 = { class: "list-item" }
const _hoisted_20 = { class: "list-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, "STRIPE PAY", -1))
const _hoisted_22 = { class: "plan" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "plan-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "version-center" }, "Enterprise"),
  /*#__PURE__*/_createElementVNode("h3", { class: "price-dollars" }, "Custom"),
  /*#__PURE__*/_createElementVNode("p", null, "Pricing")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "EVERYTHING IN PRO, PLUS:", -1))
const _hoisted_25 = { class: "list" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "purchase",
  href: "https://docs.google.com/forms/d/e/1FAIpQLSfLLBD6R9Sgm0-lXY3O5fXHobzNoAqL1iMAW-UVujV6OWpyWg/viewform",
  target: "_blank"
}, " Contact Us ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, "GET REPLY IN 24H", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-grid" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Email "),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto: hello@prodia.com" }, "hello@prodia.com"),
    /*#__PURE__*/_createTextVNode(" if you're looking for a custom plan or Enterprise priority queue. ")
  ])
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "detailed-pricing" }, [
  /*#__PURE__*/_createTextVNode(" for detailed usage pricing go to our docs: "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://docs.prodia.com/reference/pricing/" }, "docs.prodia.com/reference/pricing"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))

import Exit from "@/components/svgs/Exit.vue";
import Tick from "@/components/svgs/Tick.vue";
import { showProModal } from "@/refs/modals";
import { upgradeToPro } from "@/lib/stripe";
import { isPaid } from "@/refs/account";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProModal',
  setup(__props) {

const openPlanSettings = () => {
	window.open("https:// .stripe.com/p/login/8wMaGm6bRgYC6xWfYY", "_blank");
};

return (_ctx: any,_cache: any) => {
  const _component_modal = _resolveComponent("modal")!

  return (_unref(showProModal))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(showProModal))
          ? (_openBlock(), _createBlock(_component_modal, {
              key: 0,
              class: "modal"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: "exit",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showProModal.value = false))
                }, [
                  _createVNode(Exit)
                ]),
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, [
                        _createVNode(Tick, { class: "tick" }),
                        _createTextVNode(" Flux Schnell for testing ")
                      ]),
                      _createElementVNode("p", _hoisted_9, [
                        _createVNode(Exit, { class: "cross" }),
                        _createTextVNode(" API")
                      ]),
                      _createElementVNode("p", _hoisted_10, [
                        _createVNode(Exit, { class: "cross" }),
                        _createTextVNode(" Access to all image models ")
                      ]),
                      _createElementVNode("p", _hoisted_11, [
                        _createVNode(Exit, { class: "cross" }),
                        _createTextVNode(" Access to all video models ")
                      ])
                    ]),
                    _hoisted_12,
                    _hoisted_13
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("p", _hoisted_18, [
                        _createVNode(Tick, { class: "tick" }),
                        _createTextVNode(" API")
                      ]),
                      _createElementVNode("p", _hoisted_19, [
                        _createVNode(Tick, { class: "tick" }),
                        _createTextVNode(" Access to all image models ")
                      ]),
                      _createElementVNode("p", _hoisted_20, [
                        _createVNode(Tick, { class: "tick" }),
                        _createTextVNode(" Access to all video models ")
                      ])
                    ]),
                    (_unref(isPaid))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "purchase manage",
                          onClick: openPlanSettings
                        }, " Manage "))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "purchase",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(upgradeToPro) && _unref(upgradeToPro)(...args)))
                        }, " Upgrade ")),
                    _hoisted_21
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("p", null, [
                        _createVNode(Tick, { class: "tick" }),
                        _createTextVNode(" Tiered pricing discounts")
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(Tick, { class: "tick" }),
                        _createTextVNode(" Dedicated Slack channel with live support ")
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(Tick, { class: "tick" }),
                        _createTextVNode(" Access to beta models")
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(Tick, { class: "tick" }),
                        _createTextVNode(" Highest priority generations ")
                      ])
                    ]),
                    _hoisted_26,
                    _hoisted_27
                  ]),
                  _hoisted_28
                ]),
                _hoisted_29
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})